import { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { Button, ValidationForm } from '../../atoms';
import styles from './LandscapeStoryOrganism.module.css';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';
import dayjs from 'dayjs';
import { ImageUploader } from '../../molecules';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface LandscapeStoryOrganismProps {
  story: StoryResponseDto;
  handleOnChange: (story: StoryResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  callbackFn: (story: StoryResponseDto) => void;
}

const LandscapeStoryOrganism: FC<LandscapeStoryOrganismProps> = ({
  story,
  handleOnChange,
  handleImageOnChange,
  callbackFn,
}) => {
  const date = new Date(story.date ?? '');
  const formattedDate = dayjs(date).format('YYYY-MM-DD');
  return (
    <div className={styles.storyWrapper}>
      <ValidationForm onSubmitCallback={() => callbackFn(story)}>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={story.name}
            onChange={(e) => handleOnChange({ ...story, name: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Story</Form.Label>
          <Form.Control
            type="text"
            value={story.story ?? ''}
            onChange={(e) =>
              handleOnChange({ ...story, story: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Writer</Form.Label>
          <Form.Control
            type="text"
            value={story.writer ?? ''}
            onChange={(e) =>
              handleOnChange({ ...story, writer: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Date</Form.Label>
          <Form.Control
            type="date"
            value={formattedDate}
            onChange={(e) => handleOnChange({ ...story, date: e.target.value })}
          />
        </Form.Group>
        <Form.Label>Filename</Form.Label>
        <Form.Group className="mb-3">
          <ImageUploader
            setImage={(image: string) => {
              handleOnChange({ ...story, headerImage: image });
            }}
            setImageMeta={(imageMeta: ImageMeta) =>
              handleImageOnChange(imageMeta)
            }
            imageSrc={story.headerImage ?? undefined}
            id={story.id}
          />
        </Form.Group>
        <Button variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeStoryOrganism;
